import React, {useState} from 'react';
// import {Year2018, Year2020} from './Content';
// import { useParams } from 'react-router';
import {Link} from "react-router-dom";
// import { GlobalContext } from '../../Contexts/GlobalContext';

const Sidebar = (props) => {

    const [sideClick, setSideClick] = useState(false);

    const closeSideBar = () => setSideClick(false);

    const handleSideClick = () => setSideClick(!sideClick);



    return (

        <>
            <div className="contentWrapper">

            <div className={ sideClick ? 'sideMenuBar sideMenuBarClose' : 'sideMenuBar' }>
                <i className="fa fa-bars openIcon" onClick={handleSideClick} ></i>
            </div>

                <div className={ sideClick ? 'sidebar sidebarActive' : 'sidebar'} >

                    <i className="fa fa-times closeIcon" onClick={handleSideClick} ></i>

                    <div className="list">
                        
                        <div className="listWrapper">
                            <div className="item">
                                <Link to="/">Year 2018</Link>
                            </div>
                            <div className="item">    
                                <Link to="/">Year 2020</Link>
                            </div>
                            <div className="item">    
                                <Link to="/">Previous Events</Link>
                                <div className="sideDropDown">
                                    <Link to="/" ><i className="fa fa-caret-right"></i> Annual Reunion</Link>
                                    <Link to="/" ><i className="fa fa-caret-right"></i> Industry Talks</Link>
                                </div>
                            </div>
                        </div>
                        
                    </div>

                </div>
                <div className="mainContent" onClick={closeSideBar} >
                   {
                       props.children
                   }
                </div>
            </div>
        </>
    );

}

export default React.memo(Sidebar);